import { Tooltip } from 'bootstrap';

export default {
  mounted(el, binding) {
    if (binding.value?.label) {
      new Tooltip(el, {
        title: binding.value.label,
        placement: binding.value.placement || 'top',
        html: Boolean(binding.value.html),
      });
    }
  },
  updated(el, binding) {
    const tooltipInstance = Tooltip.getInstance(el);
    if (!binding.value?.label) {
      if (tooltipInstance) {
        try {
          tooltipInstance.dispose();
        } catch {
          // Defensive: bootstrap tooltip dispose can throw during fast unmount/update cycles.
        }
      }
      return;
    }

    if (tooltipInstance) {
      try {
        tooltipInstance.dispose();
      } catch {
        // Defensive: avoid propagating cleanup-time tooltip errors.
      }
    }

    new Tooltip(el, {
      title: binding.value.label,
      placement: binding.value.placement || 'top',
      html: Boolean(binding.value.html),
    });
  },
  unmounted(el) {
    const tooltipInstance = Tooltip.getInstance(el);
    if (tooltipInstance) {
      try {
        tooltipInstance.dispose();
      } catch {
        // Defensive: avoid propagating cleanup-time tooltip errors.
      }
    }
  },
};
